import { useEffect, useState, useCallback } from "react";
import { toast } from "sonner";
import { Award, Upload, Trash2, Eye, Loader2 } from "lucide-react";
import { api, errMsg } from "../../lib/api";

const API_ORIGIN = process.env.REACT_APP_BACKEND_URL;

export function CertificateSettings() {
  const [s, setS] = useState(null);
  const [busy, setBusy] = useState(false);
  const [v, setV] = useState(0);
  const load = useCallback(() => api.get("/admin/certificate-settings").then((r) => setS(r.data)), []);
  useEffect(() => { load(); }, [load]);
  const save = async (e) => {
    e.preventDefault();
    try { await api.put("/admin/certificate-settings", { signer_name: s.signer_name, signer_title: s.signer_title }); toast.success("Belge ayarları kaydedildi"); } catch (x) { toast.error(errMsg(x)); }
  };
  const upload = async (e) => {
    const file = e.target.files?.[0]; e.target.value = "";
    if (!file) return;
    setBusy(true);
    const fd = new FormData(); fd.append("file", file);
    try { await api.post("/admin/certificate-signature", fd); toast.success("İmza yüklendi"); await load(); setV((x) => x + 1); } catch (x) { toast.error(errMsg(x)); } finally { setBusy(false); }
  };
  const remove = async () => {
    if (!window.confirm("İmza görseli kaldırılsın mı?")) return;
    try { await api.delete("/admin/certificate-signature"); toast.success("İmza kaldırıldı"); load(); } catch (x) { toast.error(errMsg(x)); }
  };
  if (!s) return null;
  return (
    <form onSubmit={save} className="bg-white border border-zinc-200 p-4 sm:p-5 mb-5 grid gap-4" data-testid="certificate-settings">
      <div className="flex flex-wrap justify-between gap-2 items-center">
        <h2 className="font-black flex items-center gap-2"><Award size={18} className="text-[#dc2626]" />Ders Tamamlama Belgesi – Yetkili İmzası</h2>
        <span className="text-xs text-zinc-500" data-testid="certificate-issued-count">Verilen belge: {s.issued_count}</span>
      </div>
      <div className="grid sm:grid-cols-2 gap-3">
        <div><label className="label" htmlFor="cs-n">Yetkili adı soyadı</label><input id="cs-n" className="field" value={s.signer_name} onChange={(e) => setS({ ...s, signer_name: e.target.value })} data-testid="certificate-signer-name" /></div>
        <div><label className="label" htmlFor="cs-t">Unvan</label><input id="cs-t" className="field" value={s.signer_title} onChange={(e) => setS({ ...s, signer_title: e.target.value })} data-testid="certificate-signer-title" /></div>
      </div>
      <div className="flex flex-wrap items-center gap-3">
        {s.has_signature ? <img src={`${API_ORIGIN}/api/admin/certificate-signature?v=${v}`} alt="Yetkili imzası" className="h-14 w-auto border border-zinc-200 bg-white p-1" data-testid="certificate-signature-preview" />
          : <span className="text-xs text-zinc-500" data-testid="certificate-no-signature">İmza görseli yüklenmedi. Şeffaf arka planlı PNG önerilir (en fazla 2 MB).</span>}
        <label className="btn-dark !py-2 cursor-pointer text-xs">{busy ? <Loader2 size={14} className="animate-spin" /> : <Upload size={14} />}{s.has_signature ? "İmzayı Değiştir" : "İmza Yükle"}
          <input type="file" accept="image/png,image/jpeg" className="hidden" onChange={upload} data-testid="certificate-signature-input" /></label>
        {s.has_signature && <button type="button" className="text-xs underline text-[#dc2626] inline-flex items-center gap-1" onClick={remove} data-testid="certificate-signature-remove"><Trash2 size={12} />Kaldır</button>}
      </div>
      <div className="flex flex-wrap gap-2">
        <button className="btn-red !py-2 text-sm" data-testid="certificate-settings-save">Kaydet</button>
        <a href={`${API_ORIGIN}/api/admin/certificate-preview`} target="_blank" rel="noreferrer" className="btn-dark !py-2 text-sm" data-testid="certificate-preview-btn"><Eye size={14} />Örnek Belgeyi Gör</a>
      </div>
    </form>
  );
}
